import { useEnvironment } from '@publicisgroupe/p-os-components';
import { initMsalConfig } from '../utils/authConfig';
import { PublicClientApplication } from '@azure/msal-browser';

export const useRootApp = () => {
  const { settings } = useEnvironment();

  const msalConfig = initMsalConfig(
    (settings as any).azureAdClientId,
    (settings as any).azureAdTenantId
  );

  const msalInstance = new PublicClientApplication(msalConfig);

  return { msalInstance };
};
